import axios from 'axios'
const token = localStorage.getItem('token')
import router from '../../router'
import { app } from '../../main'

const state = {
	total_movies: '',
  total_series: '',
  total_servers: '',
  total_users: ''
}

const mutations = {
       SET_DASHBOARD_DATA (state, { total_movies, total_series, total_servers, total_users }){
           state.total_movies = total_movies
           state.total_series = total_series
           state.total_servers = total_servers
           state.total_users = total_users
      }
}

const actions = {
    loadDataDashboard({ commit }) {
        let vm = this;
        axios.get('dashboard/statistics?token=' + token)
          .then(function (response) {
              commit('SET_DASHBOARD_DATA', { total_movies: response.data.total_movies, total_series: response.data.total_series, total_servers: response.data.total_servers, total_users: response.data.total_users });
              //console.log(response)
          })
          .catch(function (error) {
              if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem('token')
                router.go('/')
              }
              else{
                Swal.fire("Notification", "Error retrieving data, please try reloading the page!", "error")
              }
              //console.log(error)
          });
	  }
    //
}

const getters = {
    total_movies: state => {
      return state.total_movies
    },
    total_series: state => {
      return state.total_series
    },
    total_servers: state => {
      return state.total_servers
    },
    total_users: state => {
      return state.total_users
    }
}

export default {
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js